import { useId } from "@reach/auto-id"

export const Errors = ({ id, errors }) => {
	const prefix = useId()
	const inputId = id ?? `${prefix}-error`

	if (!errors) return <></>

	return (
		<div id={inputId} className="mt-1" role="alert" aria-live="polite">
			{errors.map((error, index) => {
				return (
					<p key={index} className="text-xs text-danger">
						{error.message}
					</p>
				)
			})}
		</div>
	)
}